import { UAModules } from '@unifyapps/defs/types/modules';
import { useCallback } from 'react';
import { useUserPreferenceMutation } from '../../../../../hooks/useUserPreferenceMutation';
import type { ActionHandlerType, OnActionArgs } from '../../../../context/ActionsProvider/context';
import { useGetNoCodeComputedData } from '../../../computeContext/useGetNoCodeComputedData';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';

type SetUserPreferencePayload = {
  recordId: string;
  key: string;
  value: string;
};

function useSetUserPreference() {
  const { setUserPreference } = useUserPreferenceMutation();
  const { getNoCodeComputedData } = useGetNoCodeComputedData();

  const onSetUserPreference: ActionHandlerType = useCallback(
    async ({ action, actionContext }: OnActionArgs) => {
      const { recordId, key, value } = getNoCodeComputedData<SetUserPreferencePayload>(
        action.payload as SetUserPreferencePayload,
        actionContext,
      );
      const applicationId = (actionContext.interfaceRecord as { id: string }).id;
      await setUserPreference({
        applicationId,
        module: UAModules.INTERFACE,
        recordId,
        key,
        value,
      });
      return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
    },
    [getNoCodeComputedData, setUserPreference],
  );

  return {
    onSetUserPreference,
  };
}

export default useSetUserPreference;
